import React, { useEffect, useState } from 'react';
import { supervisedStudentApi } from '@/features/workspace/api';
import type { OpportunityItem } from '../types';
import '../tp201-projects.css';

interface OpportunitiesOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenGateway?: () => void;
}

const CARD_COLORS = ['#e8b33b', '#9e80ff', '#66b7e8', '#49ddb7', '#e8b33b', '#ff7663'];

function deadlineLabel(value: string): string {
  const text = value.replace(/^Дедлайн\s+/i, '').trim();
  return text ? `Дедлайн ${text}` : 'Дедлайн';
}

export const OpportunitiesOverlay: React.FC<OpportunitiesOverlayProps> = ({
  isOpen,
  onClose,
}) => {
  const [items, setItems] = useState<OpportunityItem[]>([]);
  const [notice, setNotice] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    supervisedStudentApi.opportunities()
      .then((rows) => setItems(rows || []))
      .catch(() => setNotice('Не удалось открыть возможности.'));
  }, [isOpen]);

  if (!isOpen) return null;

  const toggle = async (item: OpportunityItem) => {
    const next = !item.is_tracked;
    setItems((current) => current.map((row) => (row.id === item.id ? { ...row, is_tracked: next } : row)));
    try {
      await supervisedStudentApi.trackOpportunity(item.id, next);
      setNotice('');
    } catch (error) {
      setItems((current) => current.map((row) => (row.id === item.id ? { ...row, is_tracked: item.is_tracked } : row)));
      setNotice(error instanceof Error ? error.message : 'Не удалось сохранить возможность.');
    }
  };

  return (
    <div className="tp201-root" role="dialog" aria-modal="true">
      <header className="tp201-top">
        <button type="button" onClick={onClose}>← Назад</button>
        <div>
          <h1>Возможности и развитие</h1>
          <p>STUDENT · конференции, публикации и академическое развитие</p>
        </div>
        <button type="button" onClick={onClose}>Закрыть ×</button>
      </header>
      <main className="tp201-content">
        <section className="sv121-panel" style={{ ['--c' as string]: '#e8b33b' }}>
          <span className="sv121-eyebrow">ВОЗМОЖНОСТИ И РАЗВИТИЕ</span>
          <h2>Конференции, публикации и академическое развитие</h2>
          <p>Возможности вне основной научной работы под руководством: конференции, семинары, публикации, конкурсы, стажировки и школы.</p>
        </section>
        <div className="tp201-project-grid">
          {items.map((item, index) => (
            <article key={item.id} className="tp201-project-card" style={{ ['--c' as string]: CARD_COLORS[index % CARD_COLORS.length] }}>
              <small>{item.category}</small>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <div className="tp201-project-meta">
                <span className="tp201-status info">{item.badge_status || 'Активно'}</span>
                <span className="tp201-status warn">{deadlineLabel(item.deadline)}</span>
              </div>
              <div className="sv121-actions">
                <button type="button" className={`sv121-btn${item.is_tracked ? ' mint' : ''}`} onClick={() => void toggle(item)}>
                  {item.is_tracked ? 'Сохранено в мои возможности' : 'Сохранить / отслеживать'}
                </button>
              </div>
            </article>
          ))}
        </div>
        {notice ? <p className="tp201-standalone-note">{notice}</p> : null}
      </main>
    </div>
  );
};
